module.exports = "## Linear Progress\n[Linear Progress](https://www.google.com/design/spec/components/progress-activity.html#progress-activity-types-of-indicators)\nbars fill from 0% to 100% to show the progress of a task. It also will animate to\nshow there is a task waiting to be done.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/LinearProgress/README.md
 ** module id = 1007
 ** module chunks = 0
 **/